(function () {
  if (window.__nuamah) return;
  window.__nuamah = true;
  document.documentElement.classList.add('n-js');
  function init() {
    var els = [].slice.call(document.querySelectorAll('.n-reveal:not(.is-in)'));
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    els.forEach(function (e) { io.observe(e); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
